import { render } from "./kyc.vue?vue&type=template&id=d0a4c86a&scoped=true"
import script from "./kyc.vue?vue&type=script&lang=js"
export * from "./kyc.vue?vue&type=script&lang=js"

import "./kyc.vue?vue&type=style&index=0&id=d0a4c86a&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/sathikash_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0a4c86a"]])

export default __exports__